module.exports = __webpack_public_path__ + "img/delete-outlined.5821abe4.svg";